import { GlobalStyles } from "@mui/material"

import { PRINT_PAGE_ONLY_CLASS } from "./printPageOnly"

export function PrintPageOnlyStyles() {
    return (
        <GlobalStyles
            styles={(theme) => ({
                [`@page ${PRINT_PAGE_ONLY_CLASS}`]: {
                    margin: 0,
                },
                "@media print": {
                    // The sheet is much narrower than the screen, so the whole rem-based layout
                    // scales down to keep the proportions the page has in the browser.
                    [`html.${PRINT_PAGE_ONLY_CLASS}`]: {
                        fontSize: "75%",
                    },
                    [`body.${PRINT_PAGE_ONLY_CLASS}`]: {
                        page: PRINT_PAGE_ONLY_CLASS,
                        backgroundColor: theme.palette.tailwind.blue[50],
                        printColorAdjust: "exact",
                    },
                    // An open tooltip is positioned in screen pixels; on the narrower sheet it overflows the page
                    // and Chrome shrinks the whole document to fit it.
                    [`body.${PRINT_PAGE_ONLY_CLASS} .MuiPopper-root`]: {
                        display: "none",
                    },
                },
            })}
        />
    )
}
